export default [
  'Aardvark',
  'Albatross',
  'Alligator',
  'Alpaca',
  'Angelfish',
  'Anglerfish',
  'Ant',
  'Anteater',
  'Antelope',
  'Antlion',
  'Ape',
  'Armadillo',
  'Asp',
  'Baboon',
  'Badger',
  'Bandicoot',
  'Barnacle',
  'Barracuda',
  'Basilisk',
  'Bass',
  'Bat',
  'Bear',
  'Beaver',
  'Bee',
  'Beetle',
  'Bird',
  'Bison',
  'Blackbird',
  'Boar',
  'Bobcat',
  'Bonobo',
  'Bug',
  'Butterfly',
  'Buzzard',
  'Camel',
  'Capybara',
  'Cardinal',
  'Caribou',
  'Cat',
  'Caterpillar',
  'Catfish',
  'Cattle',
  'Chameleon',
  'Cheetah',
  'Chickadee',
  'Chicken',
  'Chimpanzee',
  'Chinchilla',
  'Chipmunk',
  'Clam',
  'Clownfish',
  'Cobra',
  'Condor',
  'Coral',
  'Cougar',
  'Coyote',
  'Crab',
  'Crane',
  'Crawdad',
  'Crayfish',
  'Cricket',
  'Crocodile',
  'Crow',
  'Cuckoo',
  'Deer',
  'Dingo',
  'Dinosaur',
  'Dog',
  'Dolphin',
  'Donkey',
  'Dove',
  'Dragon',
  'Dragonfly',
  'Duck',
  'Eagle',
  'Earthworm',
  'Echidna',
  'Egret',
  'Elephant',
  'Elk',
  'Emu',
  'Ermine',
  'Falcon',
  'Ferret',
  'Finch',
  'Firefly',
  'Fish',
  'Flamingo',
  'Fowl',
  'Fox',
  'Frog',
  'Gazelle',
  'Gecko',
  'Gerbil',
  'Gibbon',
  'Giraffe',
  'Goat',
  'Goldfish',
  'Goose',
  'Gopher',
  'Gorilla',
  'Grasshopper',
  'Grouse',
  'Gull',
  'Guppy',
  'Hamster',
  'Hare',
  'Harrier',
  'Hawk',
  'Hedgehog',
  'Heron',
  'Hippopotamus',
  'Horse',
  'Hummingbird',
  'Hyena',
  'Iguana',
  'Impala',
  'Jackal',
  'Jaguar',
  'Jay',
  'Jellyfish',
  'Kangaroo',
  'Kingfisher',
  'Kiwi',
  'Koala',
  'Koi',
  'Ladybug',
  'Lark',
  'Lemming',
  'Lemur',
  'Leopard',
  'Lion',
  'Llama',
  'Lobster',
  'Loon',
  'Lynx',
  'Macaw',
  'Mackerel',
  'Mammal',
  'Manatee',
  'Mandrill',
  'Marlin',
  'Marmoset',
  'Marmot',
  'Marsupial',
  'Mastodon',
  'Meerkat',
  'Mink',
  'Minnow',
  'Mockingbird',
  'Mole',
  'Mongoose',
  'Monkey',
  'Moose',
  'Mosquito',
  'Mouse',
  'Mule',
  'Muskox',
  'Narwhal',
  'Ocelot',
  'Octopus',
  'Opossum',
  'Orangutan',
  'Orca',
  'Ostrich',
  'Otter',
  'Owl',
  'Ox',
  'Panda',
  'Panther',
  'Parakeet',
  'Parrot',
  'Partridge',
  'Peacock',
  'Pelican',
  'Penguin',
  'Pig',
  'Pigeon',
  'Platypus',
  'Pony',
  'Porcupine',
  'Porpoise',
  'Puffin',
  'Puma',
  'Python',
  'Quail',
  'Quokka',
  'Rabbit',
  'Raccoon',
  'Raven',
  'Reindeer',
  'Rhinoceros',
  'Roadrunner',
  'Rooster',
  'Salamander',
  'Salmon',
  'Seahorse',
  'Shark',
  'Sheep',
  'Shrew',
  'Sloth',
  'Snail',
  'Sparrow',
  'Squid',
  'Squirrel',
  'Starfish',
  'Stingray',
  'Stoat',
  'Stork',
  'Sturgeon',
  'Swan',
  'Swift',
  'Swordfish',
  'Tapir',
  'Tarsier',
  'Tern',
  'Tiger',
  'Tortoise',
  'Toucan',
  'Turkey',
  'Turtle',
  'Tyrannosaurus',
  'Vole',
  'Wallaby',
  'Walrus',
  'Warbler',
  'Whale',
  'Wildcat',
  'Wolf',
  'Wolverine',
  'Wombat',
  'Woodpecker',
  'Wren',
  'Yak',
  'Zebra',
]
